module.exports = __webpack_public_path__ + "static/cta-bg-0223c58d1bb167fe71512d5e0fd6fa4c.png";